export enum DialogType {
  Create = 'Create',
  Delete = 'Delete',
  Inspect = 'Inspect',
  Update = 'Update',
}
